module.exports = __webpack_public_path__ + "media/SAL.ac568d77.mp4";